import Splide from '@splidejs/splide';
import {gsap} from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import CustomAnimation from "src/scripts/animation/customAnimation";
import $ from "jquery";

let splide1;
const customAnmation = new CustomAnimation();

class Home {
  init() {
    this.initPage();
    this.initParallax();
  }

  initPage = () => {

    $('.home_header').addClass('show');

    splide1 = new Splide( '.splide_01', {
      type: 'loop',
      perPage: 1,
      focus: 'center',
      autoplay: false,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: true,
      throttle: 300,
    } );
    splide1.mount();
  }
  initParallax = () =>  {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header_background');

    customAnmation.animateBgImage('.zunaechst_background', '.zunaechst');
    customAnmation.animateTextAlpha('.zunaechst_text_holder');

    customAnmation.animateBgImage('.zugang_background', '.zugang');
    customAnmation.animateTextAlpha('.zugang_text_holder');

    customAnmation.animateBgImage('.zustimmung_background', '.zustimmung');
    customAnmation.animateTextVertical('.zustimmung_content');
    customAnmation.animateTextAlpha('.zustimmung_text_holder');

    customAnmation.animateBgImage('.zutaten_background', '.zutaten');
    customAnmation.animateTextAlpha('.zutaten_text_holder');
    customAnmation.animateTextVertical('.zutaten_content');
  }
}

export default Home;
